/* dein-rasenroboter.de – Premium-Funktionen (sixtyweb)
   1) Kartenbild: freigestelltes Produktfoto automatisch nach vorne, Markenbild beim Hover
   2) Warenkorb: „Passt dazu“-Empfehlungen + Versandkostenfrei-Balken
   3) Kollektionen: Modell-Auswahl aus den Produkttiteln */
(function () {
  'use strict';
  var DRR = window.DRR || {};
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  /* Preisformat wie im Shop: €22,99 */
  var money = { format: function (v) { return Number(v).toFixed(2).replace('.', ',') + ' €'; } };
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function h(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function sized(u, w) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* ---------- 1) Kartenbild ---------- */
  var VER = 'v1';
  function classify(url) {
    return new Promise(function (res) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var c = document.createElement('canvas'), n = 40; c.width = n; c.height = n;
          var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, n, n);
          var d = x.getImageData(0, 0, n, n).data, bw = 0, bt = 0, wf = 0;
          for (var i = 0; i < n * n; i++) {
            var px = i % n, py = (i / n) | 0, m = Math.min(d[i * 4], d[i * 4 + 1], d[i * 4 + 2]), w = m > 232 && d[i * 4 + 3] > 200;
            if (w) wf++;
            if (px < 3 || px > n - 4 || py < 3 || py > n - 4) { bt++; if (w) bw++; }
          }
          res({ border: bw / bt, white: wf / (n * n) });
        } catch (e) { res(null); }
      };
      img.onerror = function () { res(null); };
      img.src = sized(url, 64);
    });
  }
  function isCutout(r) { return r && r.border >= 0.9 && r.white >= 0.35 && r.white <= 0.86; }
  function pick(urls) {
    return classify(urls[0]).then(function (r0) {
      if (r0 && r0.border >= 0.8) return 0; /* erstes Bild ist schon hell/freigestellt */
      var i = 1;
      function next() {
        if (i >= urls.length) return 0;
        var k = i++;
        return classify(urls[k]).then(function (r) { return isCutout(r) ? k : next(); });
      }
      return next();
    });
  }
  function srcset(u) { return [165, 360, 533, 720, 940].map(function (w) { return sized(u, w) + ' ' + w + 'w'; }).join(', '); }
  function apply(box, urls, idx) {
    box.dataset.drrDone = '1';
    if (!idx) return;
    var imgs = box.querySelectorAll('img'), first = imgs[0];
    if (!first) return;
    var hover = imgs[1];
    if (!hover) {
      hover = first.cloneNode(false);
      hover.removeAttribute('fetchpriority');
      hover.loading = 'lazy';
      first.after(hover);
    }
    hover.srcset = srcset(urls[0]); hover.src = sized(urls[0], 533);
    first.srcset = srcset(urls[idx]); first.src = sized(urls[idx], 533);
  }
  function handleCard(box) {
    if (box.dataset.drrDone) return;
    box.dataset.drrDone = '0';
    var urls = (box.dataset.drrImgs || '').split('|').filter(Boolean).map(function (u) { return u.indexOf('//') === 0 ? location.protocol + u : u; });
    if (urls.length < 2) { box.dataset.drrDone = '1'; return; }
    var key = 'drr-img-' + VER + '-' + box.dataset.drrPid, cached = store(key);
    if (cached !== null && cached !== undefined) { apply(box, urls, +cached); return; }
    pick(urls).then(function (idx) { store(key, String(idx)); apply(box, urls, idx); });
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); handleCard(e.target); } });
  }, { rootMargin: '400px 0px' }) : null;
  function scanCards(root) {
    (root || document).querySelectorAll('[data-drr-imgs]:not([data-drr-seen])').forEach(function (b) {
      b.setAttribute('data-drr-seen', '1');
      if (io) io.observe(b); else handleCard(b);
    });
  }

  /* ---------- eBay-Siegel im Hero ---------- */
  function ebayHero() {
    var a = document.querySelector('.drr-hero__rating');
    if (!a || a.dataset.eb || !DRR.rt) return;
    a.dataset.eb = '1';
    var s = a.querySelector('span:last-child');
    if (s) s.innerHTML = '<strong>' + DRR.rt + '/5</strong> · ' + DRR.rc + ' Bewertungen <span class="drr-hero__src">(Shop &amp; eBay)</span>';
  }

  /* ---------- 2) Warenkorb ---------- */
  function freeShip(root) {
    var el = (root || document).querySelector('[data-drr-ship]');
    var lim = +(DRR.freeShip || 0);
    if (!el || !lim || el.dataset.drrDone) return;
    el.dataset.drrDone = '1';
    var total = +el.dataset.total || 0, rest = lim - total, pct = Math.min(100, Math.round(total / lim * 100));
    el.classList.add('drr-cd-ship--bar');
    el.innerHTML = '<div class="drr-cd-ship__txt">' + (rest > 0
      ? 'Noch <strong>' + money.format(rest / 100) + '</strong> bis zum <strong>kostenlosen Versand</strong>'
      : '🎉 <strong>Kostenloser Versand</strong> – Lieferung in 1–3 Werktagen') + '</div>' +
      '<div class="drr-cd-ship__bar"><span style="width:' + pct + '%"></span></div>';
  }
  var xsCache = {};
  function crossSell(root) {
    var box = (root || document).querySelector('[data-drr-xs]');
    if (!box || box.dataset.drrDone) return;
    box.dataset.drrDone = '1';
    var pid = box.dataset.pid, inCart = (box.dataset.in || '').split(',');
    if (!pid) return;
    function load(intent) {
      return fetch(base + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=' + intent).then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (d) { return d.products || []; }).catch(function () { return []; });
    }
    var heading = 'Passt dazu';
    function fallback() {
      heading = box.dataset.blade ? 'Passt zu deinen Klingen · im Set 5 % günstiger' : 'Praktisches Zubehör';
      var hs = (DRR.xs || []).filter(Boolean);
      return Promise.all(hs.map(function (hd) { return fetch(base + 'products/' + hd + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
        .then(function (a) { return a.filter(Boolean); });
    }
    var p = xsCache[pid] || (xsCache[pid] = load('complementary').then(function (a) { return a.length ? a : fallback(); }));
    p.then(function (list) {
      var seen = {};
      list = list.filter(function (x) { if (seen[x.id] || inCart.indexOf(String(x.id)) > -1 || !x.available) return false; seen[x.id] = 1; return true; }).slice(0, 3);
      if (!list.length) return;
      box.innerHTML = '<p class="drr-xs__h">' + heading + '</p><ul class="drr-xs__list" role="list">' + list.map(function (x) {
        var v = (x.variants || []).filter(function (v) { return v.available; })[0] || x.variants[0];
        var single = true, vt = x.variants.length > 1 && v.title ? ' · ' + v.title : '';
        var img = x.featured_image ? sized(x.featured_image.indexOf('//') === 0 ? location.protocol + x.featured_image : x.featured_image, 160) : '';
        return '<li class="drr-xs__item"><a href="' + x.url + '" class="drr-xs__img">' + (img ? '<img src="' + img + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
          '<div class="drr-xs__info"><a href="' + x.url + '" class="drr-xs__t">' + h(x.title) + '</a><span class="drr-xs__p">' + money.format((v.price || x.price) / 100) + h(vt) + '</span></div>' +
          (single ? '<button type="button" class="drr-xs__add" data-vid="' + v.id + '" aria-label="' + h(x.title) + ' hinzufügen">+ Hinzufügen</button>' : '<a class="drr-xs__add" href="' + x.url + '">Ansehen</a>') + '</li>';
      }).join('') + '</ul>';
      box.hidden = false;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button.drr-xs__add');
    if (!b) return;
    b.disabled = true; b.textContent = '…';
    var drawer = document.querySelector('cart-drawer');
    fetch(base + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.dataset.vid, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (drawer && d.sections && drawer.renderContents) { d.id = d.items && d.items[0] && d.items[0].id; drawer.renderContents(d); }
      else location.reload();
    }).catch(function () { b.disabled = false; b.textContent = '+ Hinzufügen'; });
  });
  function drawerInit() { var d = document.getElementById('CartDrawer'); if (d) { freeShip(d); crossSell(d); } }

  /* ---------- 3) Modell-Auswahl auf Kollektionen ---------- */
  function models() {
    var wrap = document.querySelector('[data-drr-models]');
    if (!wrap || wrap.dataset.drrDone) return;
    if (!window.DrrFinderParse) { window.addEventListener('load', models, { once: true }); return; }
    wrap.dataset.drrDone = '1';
    var handle = wrap.dataset.handle, brand = wrap.dataset.brand;
    var all = [];
    function page(n) {
      return fetch(base + 'collections/' + handle + '/products.json?limit=250&page=' + n).then(function (r) { return r.json(); }).then(function (d) {
        all = all.concat(d.products || []);
        return (d.products || []).length === 250 && n < 6 ? page(n + 1) : all;
      });
    }
    page(1).then(function (products) {
      var res = window.DrrFinderParse(handle, brand, products);
      if (!res || res.models.length < 3) return;
      var chips = wrap.querySelector('[data-drr-chips]'), grid = document.getElementById('ProductGridContainer');
      var out = document.createElement('div'); out.className = 'drr-mres page-width'; out.hidden = true;
      if (grid) grid.parentNode.insertBefore(out, grid);
      chips.innerHTML = '<button type="button" class="drr-chip is-on" data-i="-1">Alle Modelle</button>' + res.models.map(function (m, i) {
        return '<button type="button" class="drr-chip" data-i="' + i + '">' + h(m[0]) + ' <span>' + m[1].length + '</span></button>';
      }).join('');
      wrap.hidden = false;
      if (res.models.length > 10 && innerWidth >= 750) {
        chips.classList.add('is-collapsed');
        if (chips.scrollHeight > chips.clientHeight + 4) {
          var more = document.createElement('button'); more.type = 'button'; more.className = 'drr-models__more';
          more.textContent = 'Alle ' + res.models.length + ' Modelle anzeigen';
          more.addEventListener('click', function () { var c = chips.classList.toggle('is-collapsed'); more.textContent = c ? 'Alle ' + res.models.length + ' Modelle anzeigen' : 'Weniger anzeigen'; });
          chips.after(more);
        } else chips.classList.remove('is-collapsed');
      }
      chips.addEventListener('click', function (e) {
        var b = e.target.closest('.drr-chip'); if (!b) return;
        chips.querySelectorAll('.drr-chip').forEach(function (c) { c.classList.toggle('is-on', c === b); });
        var i = +b.dataset.i, facets = document.querySelector('.facets-container, .facets-wrapper');
        if (i < 0) { out.hidden = true; if (grid) grid.hidden = false; if (facets) facets.hidden = false; return; }
        var m = res.models[i], uni = res.universal.filter(function (p) { return m[1].indexOf(p) < 0; });
        out.innerHTML = '<p class="drr-mres__h">Passend für <strong>' + h(m[0]) + '</strong> · ' + m[1].length + ' Produkt' + (m[1].length === 1 ? '' : 'e') + '</p><ul class="drr-mres__grid" role="list">' + m[1].map(card).join('') + '</ul>' +
          (uni.length ? '<p class="drr-mres__h drr-mres__h--2">Passt außerdem für alle Modelle</p><ul class="drr-mres__grid" role="list">' + uni.map(card).join('') + '</ul>' : '');
        out.hidden = false; if (grid) grid.hidden = true; if (facets) facets.hidden = true;
        scanCards(out);
        var top = wrap.getBoundingClientRect().top + scrollY - 90; if (scrollY > top) scrollTo({ top: top, behavior: 'smooth' });
      });
    }).catch(function () {});
  }
  function mat(t) { return /titan/i.test(t) ? 'Titan' : /carbon/i.test(t) ? 'Carbon' : /edelstahl/i.test(t) ? 'Edelstahl' : ''; }
  function card(p) {
    var v = p.variants || [], pr = Math.min.apply(null, v.map(function (x) { return +x.price; })), cp = Math.max.apply(null, v.map(function (x) { return +(x.compare_at_price || 0); }));
    var av = v.some(function (x) { return x.available; }), imgs = (p.images || []).slice(0, 6).map(function (i) { return i.src.split('&width')[0]; });
    var title = p.title.split(' | '), m = mat(p.title), off = cp > pr ? Math.round((1 - pr / cp) * 100) : 0;
    return '<li class="drr-mcard"><a href="' + base + 'products/' + p.handle + '">' +
      '<div class="drr-mcard__media media--hover-effect" data-drr-pid="' + p.id + '" data-drr-imgs="' + imgs.join('|') + '">' + (imgs[0] ? '<img src="' + sized(imgs[0], 533) + '" alt="' + h(p.title) + '" loading="lazy" width="533" height="533">' : '') +
      (off >= 3 ? '<span class="drr-mcard__badge">−' + off + ' %</span>' : '') + (av ? '' : '<span class="drr-mcard__badge drr-mcard__badge--out">Ausverkauft</span>') + '</div>' +
      '<div class="drr-mcard__body">' + (m ? '<p class="drr-card-eb">' + m + '</p>' : '') + '<p class="drr-mcard__t">' + h(title[0]) + '</p>' + (title[1] ? '<p class="drr-mcard__sub">' + h(title.slice(1).join(' · ')) + '</p>' : '') +
      '<p class="drr-mcard__p">' + (cp > pr ? '<s>' + money.format(cp) + '</s> ' : '') + '<strong>' + money.format(pr) + '</strong></p>' +
      (av ? '<p class="drr-card-stock"><span aria-hidden="true"></span>Auf Lager · 1–3 Werktage</p>' : '') + '</div></a></li>';
  }


  /* ---------- Moderne Optik: Einblenden & Akzentwörter ---------- */
  var RV = '.drr-section .drr-head, .drr-cat, .drr-usp, .card-wrapper, .drr-guide, .drr-split, .drr-service, .drr-faq details, .drr-pl__spec, .drr-foot__trust li, .drr-mcard, .drr-about, .drr-rev__score, .drr-seo';
  var rvIO = ('IntersectionObserver' in window) && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rvIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function reveal(root) {
    if (!rvIO) return;
    document.documentElement.classList.add('drr-anim');
    (root || document).querySelectorAll(RV).forEach(function (el) {
      if (el.dataset.drrRv || el.closest('cart-drawer, .drr-hero, .drawer, .predictive-search, .header-wrapper')) return;
      el.dataset.drrRv = '1';
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--rv-d', (Math.min(sib, 5) * 0.07) + 's');
      el.classList.add('drr-rv');
      var r = el.getBoundingClientRect();
      if (r.top < innerHeight * 0.92 && r.bottom > 0) { requestAnimationFrame(function () { el.classList.add('is-in'); }); }
      else rvIO.observe(el);
    });
  }
  function accentWords() {
    document.querySelectorAll('.drr .drr-h2, .drr-guides .drr-h2').forEach(function (h) {
      if (h.dataset.drrAw || h.children.length || h.closest('.drr-pl, .drr-split')) return;
      h.dataset.drrAw = '1';
      var t = h.textContent.trim(), i = t.lastIndexOf(' ');
      if (i < 1) return;
      var last = t.slice(i + 1), end = /[?!.:]$/.test(last) ? last.slice(-1) : '';
      if (end) last = last.slice(0, -1);
      h.innerHTML = '';
      h.appendChild(document.createTextNode(t.slice(0, i + 1)));
      var s = document.createElement('span'); s.className = 'drr-accent-word'; s.textContent = last; h.appendChild(s);
      if (end) h.appendChild(document.createTextNode(end));
    });
  }

  /* ---------- Intelligente Suche: Vorschläge vor dem Tippen ---------- */
  var SX = null;
  try { SX = JSON.parse((document.getElementById('drr-sx-data') || {}).textContent || 'null'); } catch (e) {}
  function sxCard(p) {
    var t = p.t.split(' | ')[0], off = p.c > p.p ? Math.round((1 - p.p / p.c) * 100) : 0;
    var imgs = (p.i || []).map(function (u) { return u.indexOf('//') === 0 ? location.protocol + u : u; });
    return '<li class="drr-sx__card"><a href="' + p.u + '">' +
      '<div class="drr-sx__media media--hover-effect" data-drr-pid="' + p.id + '" data-drr-imgs="' + imgs.join('|') + '">' + (imgs[0] ? '<img src="' + sized(imgs[0], 360) + '" alt="" loading="lazy" width="360" height="360">' : '') +
      (off >= 3 ? '<span class="drr-sx__off">−' + off + ' %</span>' : '') + '</div>' +
      '<p class="drr-sx__t">' + h(t) + '</p><p class="drr-sx__p"><strong>' + money.format(p.p / 100) + '</strong>' + (off >= 3 ? ' <s>' + money.format(p.c / 100) + '</s>' : '') + '</p></a></li>';
  }
  function searchInit() {
    if (!SX) return;
    document.querySelectorAll('predictive-search.search-modal__form, details-modal.header__search predictive-search').forEach(function (ps) {
      if (ps.dataset.drrSx) return; ps.dataset.drrSx = '1';
      var input = ps.querySelector('input[type="search"]'); if (!input) return;
      var panel = document.createElement('div'); panel.className = 'drr-sx'; panel.hidden = true;
      panel.innerHTML = (SX.terms.length ? '<p class="drr-sx__h">Beliebte Suchanfragen</p><div class="drr-sx__chips">' + SX.terms.map(function (t) { return '<button type="button" class="drr-sx__chip" data-q="' + h(t) + '"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' + h(t) + '</button>'; }).join('') + '</div>' : '') +
        (SX.products.length ? '<p class="drr-sx__h">Jetzt im Trend</p><ul class="drr-sx__grid" role="list">' + SX.products.filter(function (p) { return p.a; }).slice(0, 6).map(sxCard).join('') + '</ul>' : '') +
        '<a class="drr-sx__help" href="mailto:info@dein-rasenroboter.de">Nicht fündig geworden? Schick uns deine Typnummer – wir finden das passende Teil.</a>';
      ps.appendChild(panel);
      function upd() {
        var open = !!input.closest('details[open]') || document.activeElement === input;
        panel.hidden = !(open && !input.value.trim());
        if (!panel.hidden) { if (innerWidth < 750) panel.style.setProperty('--drr-sx-top', Math.round(ps.getBoundingClientRect().bottom + 6) + 'px'); scanCards(panel); }
      }
      input.addEventListener('focus', upd); input.addEventListener('input', upd);
      var det = input.closest('details'); if (det) det.addEventListener('toggle', function () { setTimeout(upd, 60); });
      panel.addEventListener('click', function (e) {
        var c = e.target.closest('.drr-sx__chip'); if (!c) return;
        input.value = c.dataset.q; input.dispatchEvent(new Event('input', { bubbles: true })); input.focus(); upd();
      });
      panel.addEventListener('mousedown', function (e) { if (e.target.closest('.drr-sx__chip')) e.preventDefault(); });
    });
  }

  /* ---------- Barrierefreiheit: fehlende Alt-Texte, Labels, iframe-Titel ---------- */
  function a11y() {
    document.querySelectorAll('img:not([alt])').forEach(function (i) { i.setAttribute('alt', /verified/i.test(i.src) ? 'Verifizierter Kauf' : ''); });
    document.querySelectorAll('input.quantity__input:not([aria-label])').forEach(function (i) { i.setAttribute('aria-label', 'Anzahl'); });
    document.querySelectorAll('iframe:not([title])').forEach(function (f) { f.setAttribute('title', 'Eingebetteter Inhalt'); });
  }
  /* ---------- Start ---------- */

  // Warenkorb-Garage: Mähroboter fährt ein, sobald der Warenkorb (wieder) sichtbar ist
  function garageDrive() {
    var pending = false;
    var drawerOpen = function () { var d = document.querySelector('cart-drawer'); return d && d.classList.contains('active'); };
    var go = function () {
      var b = document.getElementById('cart-icon-bubble'); if (!b || !b.querySelector('.drr-mower')) return;
      pending = false;
      b.classList.remove('drr-drive'); void b.offsetWidth; b.classList.add('drr-drive');
      setTimeout(function () { var x = document.getElementById('cart-icon-bubble'); if (x) x.classList.remove('drr-drive'); }, 1800);
    };
    var tryGo = function () { if (pending && !drawerOpen()) go(); };
    var mark = function () { pending = true; setTimeout(tryGo, 700); setTimeout(tryGo, 1500); };
    var d = document.querySelector('cart-drawer');
    if (d && 'MutationObserver' in window) new MutationObserver(function () { if (!drawerOpen()) setTimeout(tryGo, 250); }).observe(d, { attributes: true, attributeFilter: ['class'] });
    try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || e.source !== 'cart-items') mark(); }); return; } } catch (err) {}
    document.addEventListener('submit', function (e) { if (e.target && e.target.action && /\/cart\/add/.test(e.target.action)) mark(); }, true);
  }
  // Fremd-Popup der App GetSiteControl entfernen (eigenes Popup ist im Theme)
  function killGsc() {
    var kill = function () { document.querySelectorAll('getsitecontrol-widget,[id^="getsitecontrol-"]').forEach(function (e) { e.remove(); }); };
    // GSC-Popup sperrt das Scrollen (html overflow:hidden), obwohl es unsichtbar ist -> wieder freigeben
    var unlock = function () {
      var b = document.body, h = document.documentElement;
      Array.prototype.slice.call(b.classList).forEach(function (c) { if (/^getsitecontrol-/.test(c)) b.classList.remove(c); });
      if (!document.querySelector('.drr-pop.is-open')) {
        if (h.style.overflow === 'hidden') h.style.overflow = '';
        if (b.style.overflow === 'hidden') b.style.overflow = '';
        if (b.style.position === 'fixed' && !b.classList.contains('overflow-hidden')) { b.style.position = ''; b.style.top = ''; }
      }
    };
    kill(); unlock();
    if ('MutationObserver' in window) {
      new MutationObserver(function () { kill(); unlock(); }).observe(document.body, { childList: true, attributes: true, attributeFilter: ['class', 'style'] });
      new MutationObserver(unlock).observe(document.documentElement, { attributes: true, attributeFilter: ['style', 'class'] });
    }
  }
  function boot() {
    ebayHero(); killGsc(); garageDrive(); a11y(); accentWords(); reveal(); scanCards(); drawerInit(); models(); searchInit();
    var cd = document.getElementById('CartDrawer') && document.querySelector('cart-drawer');
    if (cd && 'MutationObserver' in window) new MutationObserver(function () { drawerInit(); }).observe(cd, { childList: true, subtree: true });
    var t; if ('MutationObserver' in window) new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { scanCards(); reveal(); a11y(); }, 120); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
